/** `{{Name}}`, the placeholder form the backend-managed translations use. */
const BACKEND_PLACEHOLDER = /\{\{\s*([A-Za-z0-9_]+)\s*\}\}/g;

/**
 * Fills the `{{Name}}` placeholders of a backend-managed translation.
 *
 * The web app's i18n is configured for single-brace placeholders (see `translations/index.ts`), so `t()` leaves these
 * tokens as they are and cannot fill them. The API writes them with the property names of its own error details, so
 * names are matched case-insensitively: `details.retryAfterSeconds` fills `{{RetryAfterSeconds}}`.
 *
 * A placeholder without a value is left in the text instead of being blanked, so a missing value stays visible.
 */
export const fillPlaceholders = (text: string, values?: Record<string, string | number>): string => {
  if (!text || !values) return text;

  const valuesByName = new Map(Object.entries(values).map(([name, value]) => [name.toLowerCase(), String(value)]));
  return text.replace(
    BACKEND_PLACEHOLDER,
    (token: string, name: string) => valuesByName.get(name.toLowerCase()) ?? token,
  );
};
